import { DataObjectUpload } from './DataObjectUpload';
import React from 'react';
import { ApiError } from '../../common/ApiClient';
import { GetApiErrorMessage } from '../../common/utils/ValidationMessagesMap';
import { DataObjectDownload } from './DataObjectDownload';
import { DataObjectType } from '../types';

interface DataObjectExcelActionsProps {
  id?: number;
  isDraft?: boolean;
  isActive?: boolean;
  isInput: boolean;
  isReport: boolean;
  isIntermediate: boolean;
  onError?: (
    apiErrors: ApiError[],
    getErrorMessage?: GetApiErrorMessage,
  ) => void;
  mode?: 'edit' | 'clone' | 'create';
  dataObjectType: DataObjectType;
  hasPermissionToManage?: boolean;
}

export const DataObjectExcelActions = ({
  id,
  isDraft = false,
  isActive = false,
  isInput,
  isReport,
  isIntermediate,
  onError,
  mode,
  dataObjectType,
  hasPermissionToManage = true,
}: Readonly<DataObjectExcelActionsProps>) => {
  return (
    <>
      {hasPermissionToManage && (isDraft || isActive) && (
        <DataObjectUpload
          id={id}
          isInput={isInput}
          isReport={isReport}
          isIntermediate={isIntermediate}
          isDraft={isDraft}
          onError={onError}
          mode={mode}
          dataObjectType={dataObjectType}
        />
      )}
      {id && (
        <DataObjectDownload
          id={id}
          isInput={isInput}
          isReport={isReport}
          isIntermediate={isIntermediate}
        />
      )}
    </>
  );
};
